"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themeType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/** @deprecated themeType use context mui theme */
const themeType = exports.themeType = _propTypes.default.oneOf(Object.values(_constants.themeKey));